import React from 'react';

function Services() {
  return (
    <section id="services">
      <h2>Our Services</h2>
      <ul>
        <li>Business Strategy Consulting</li>
        <li>Technology Solutions</li>
        <li>Project Management</li>
        <li>Training & Capacity Building</li>
      </ul>
    </section>
  );
}

export default Services;
